import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteDataset } from 'action/dataset'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (title) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully deleted`
    },
    title: {
      error: `There has been an issue deleting ${title}`,
      success: 'Dataset deleted'
    }
  }
})

const DeleteDataset = ({ deleteDataset, dataset: { uuid, title }, pagination }) => {
  const handleSubmit = () => deleteDataset(uuid)

  const { decide, outcome } = generateModalText(title)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>Delete Dataset</a>
  )
}

DeleteDataset.propTypes = {
  dataset: PropTypes.object,
  deleteDataset: PropTypes.func,
  pagination: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteDataset: bindActionCreators(deleteDataset, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.dataset.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteDataset)
